<template>
    <div data-toggle="tooltip" data-placement="bottom" :title="message">
        <span class="btn-inner--icon">
            <i :class="[icon, `mdi-${size}`]" :style="{color: color}"></i>
        </span>
    </div>
</template>

<script>
    export default {
        name: 'ContentLock',

        props: {
            icon: {
                type: String,
                default: 'mdi mdi-lock-outline'
            },
            message: {
                type: String,
                required: false,
            },
            size: {
                type: String,
                default: "36px"
            },
            color: {
                type: String,
                default: "#fff"
            }
        },
    }
</script>